function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: "150",
  strokeLinecap: "round",
  d: "M400 202h480M400 502h480M400 802h480"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#000",
  cx: "170",
  cy: "202",
  r: "100"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#000",
  cx: "170",
  cy: "502",
  r: "100"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#000",
  cx: "170",
  cy: "802",
  r: "100"
})));